var wishlistListingDataAttr = 'wishlist-toggle-listing';
var wishlistToggleButtons = '[data-' + wishlistListingDataAttr + ']';
var addToWishlistSelector = '[data-bind="add-to-wishlist"]';
var removeFromWishlistSelector = '[data-bind="remove-from-wishlist"]';
var response = '[data-bind="wishlist-response"]';

var apiEndpoint = '/api/my/wishlist/';

function bindWishListButtonClick() {
  $(document).on('click', addToWishlistSelector, handleAddToWishlistClick);
  $(document).on('click', removeFromWishlistSelector, handleRemoveFromWishlistClick);
}

function handleAddToWishlistClick(e) {
  e.preventDefault();
  addToWishlistButtonClicked(listingIdFromClick(e));
}

function handleRemoveFromWishlistClick(e) {
  e.preventDefault();
  removeFromWishlistButtonClicked(listingIdFromClick(e));
}

function listingIdFromClick(clickEvent) {
  var button = $(clickEvent.target).closest(wishlistToggleButtons);
  return button.data(wishlistListingDataAttr);
}

function removeFromWishlistButton(listingId) {
  return $(wishlistToggleButtonsSelectorForListing(listingId) + removeFromWishlistSelector);
}

function addToWishlistButton(listingId) {
  return $(wishlistToggleButtonsSelectorForListing(listingId) + addToWishlistSelector);
}

function wishlistToggleButtonsSelectorForListing(listingId) {
  return '[data-' + wishlistListingDataAttr + '="' + listingId + '"]';
}

function addToWishlistButtonClicked(listingId) {
  addToWishlist(listingId)
    .done(function () {
      addToWishlistButton(listingId).addClass('hide');
      removeFromWishlistButton(listingId).removeClass('hide');
      $(response).stop()
        .show()
        .delay(3500)
        .hide('fast');
    });
}

function removeFromWishlistButtonClicked(listingId) {
  removeFromWishlist(listingId)
    .done(function () {
      removeFromWishlistButton(listingId).addClass('hide');
      addToWishlistButton(listingId).removeClass('hide');
    });
}

function addToWishlist(listingId) {
  return ajaxRequest(listingId, 'put');
}

function removeFromWishlist(listingId) {
  return ajaxRequest(listingId, 'destroy');
}

function apiEndpointForListing(listingId) {
  return apiEndpoint + listingId;
}

function ajaxRequest(listingId, httpMethod) {
  var url = apiEndpointForListing(listingId);
  return Reverb.APIRequest[httpMethod](url);
}

module.exports = {
  init: bindWishListButtonClick,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/wish_list.js